import { type Theme, type TypographyStyle } from "@mui/material/styles";

import {
  type InfoMessageColor,
  type InfoMessageSize,
} from "ui/info-message/info-message.types";

import { colors } from "design-tokens";

export const INFO_MESSAGE_GAP = 0.5;

export const INFO_MESSAGE_BORDER_WIDTH = 1;

/** `secondary` is `navy[600]`, a step under `secondary.main`; no palette slot holds it. */
export const INFO_MESSAGE_COLOR: Record<InfoMessageColor, (theme: Theme) => string> = {
  primary: (theme) => theme.palette.primary.main,
  secondary: () => colors.navy[600],
  info: (theme) => theme.palette.info.main,
  inherit: (theme) => theme.palette.grey[600],
  success: (theme) => theme.palette.success.main,
  warning: (theme) => theme.palette.warning.main,
  error: (theme) => theme.palette.error.main,
};

/** Figma borders info, success and warning on `300` and error on `critical[200]` — steps no palette slot holds. */
export const INFO_MESSAGE_BORDER_COLOR: Record<InfoMessageColor, (theme: Theme) => string> = {
  primary: (theme) => theme.palette.primary.light,
  secondary: (theme) => theme.palette.secondary.light,
  info: () => colors.blue[300],
  inherit: (theme) => theme.palette.grey[300],
  success: () => colors.success[300],
  warning: () => colors.warning[300],
  error: () => colors.critical[200],
};

type InfoMessageSizeTokens = {
  glyph: number;
  padding: number;
  typography: (theme: Theme) => TypographyStyle;
};

export const INFO_MESSAGE_SIZE: Record<InfoMessageSize, InfoMessageSizeTokens> = {
  large: { glyph: 16, padding: 1, typography: (theme) => theme.typography.body1 },
  medium: { glyph: 16, padding: 1, typography: (theme) => theme.typography.body2 },
  small: {
    glyph: 14,
    padding: 0.75,
    typography: (theme) => ({
      ...theme.typography.caption,
      fontWeight: theme.typography.fontWeightRegular,
    }),
  },
};
